import { Box, Card, CardContent, Grid, TextField, Typography, Divider } from '@mui/material';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Sitemap = () => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                border: '1px solid #ccc',
                borderRadius: '8px'
            }}
        >
            <Card>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h5">Thông tin Sitemap</Typography>
                            <Divider />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField fullWidth label="Sitemap 1" />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField fullWidth label="Sitemap 2" />
                        </Grid>
                        <Grid item xs={12}>
                            <Box sx={{ textAlign: 'right' }}>
                                <Button
                                    variant="outlined"
                                    theme={theme}
                                    style={{ color: 'white', borderColor: '#1976D2', backgroundColor: '#1976D2' }}
                                >
                                    Thêm files
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Box>
    );
};

export default Sitemap;
